import { render } from "./SingleSelect.vue?vue&type=template&id=67efd305&scoped=true"
import script from "./SingleSelect.vue?vue&type=script&lang=js"
export * from "./SingleSelect.vue?vue&type=script&lang=js"

import "./SingleSelect.vue?vue&type=style&index=0&id=67efd305&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67efd305"]])

export default __exports__